import React, { memo, useCallback, useState } from 'react';
import { ActivityIndicator, Pressable, StyleSheet, View } from 'react-native';
import { COLORS } from '@bcm/constants';

const GlobalPressable = (props) => {
	const [isLoading, setIsLoading] = useState(false);

	const onPress = useCallback(async () => {
		let timeoutId;
		if(props.onPress) {
			if (!props.isLockingSuppressed) setIsLoading(true);
			if (props.isLockingForced) {
				setIsLoading(true);
				timeoutId = setTimeout(() => setIsLoading(false), 5000);
			}
			await props.onPress();
			setIsLoading(false);
			if (timeoutId) clearTimeout(timeoutId);
			// if (!props.isLockingSuppressed && !props.isLockingForced) setIsLoading(false);
			// TODO: check if android/IOS wizard is loading slowly
		}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.onPress]);

	return (
		<Pressable
			style={[
				{ opacity: isLoading ? 0.5 : 1 },
				props.style,
			]}
			onPress={onPress}
			disabled={props.disabled || isLoading}
			android_ripple={props.android_ripple}
			testID={props.testID}
		>
			{isLoading && <View style={styles.activityContainer}>
				<ActivityIndicator
					size='large'
					color={COLORS.accent}
				/>
			</View>}
			{props.children}
		</Pressable>
	);
};

const styles = StyleSheet.create({
	activityContainer: {
		...StyleSheet.absoluteFill,
		justifyContent: 'center',
		alignItems: 'center',
	}
});

export default memo(GlobalPressable);